import React from 'react'
import Hero from '../components/Hero'
import CampaignSection from '../components/CampaignSection'
import FeaturedProducts from '../components/FeaturedProducts'
import Features from '../components/Features'
import Reviews from '../components/Reviews'
import BlogSection from '../components/BlogSection'
import LocalSEOSchema from '../components/LocalSEOSchema'
import ReviewSchema from '../components/ReviewSchema'
import PerformanceOptimizer from '../components/PerformanceOptimizer'
import HowItWorks from '../components/HowItWorks'
import EventImagesSection from '../components/EventImagesSection'
import BusinessAreasSection from '../components/BusinessAreasSection'
import ProductBrandLogosSectionWrapper from '../components/ProductBrandLogosSectionWrapper'
import SponsorLogosSectionWrapper from '../components/SponsorLogosSectionWrapper'
import HomeShell from '../components/home/HomeShell'
import HomeBookingBar from '../components/home/HomeBookingBar'
import { Helmet } from 'react-helmet-async'
import { useEmailSettings } from '../hooks/useEmailSettings'

const HomePage = () => {
  const { settings } = useEmailSettings()
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : ''

  return (
    <>
      <Helmet>
        <title>Hyra festutrustning Skåne – ljud, ljus & PA online{settings.company_name ? ` | ${settings.company_name}` : ' | festutrustning.se'}</title>
        <meta
          name="description"
          content="Hyra PA, ljus och scen i Skåne med leverans och tydliga paket. Boka festutrustning online för student, bröllop och företag – rådgivning från festutrustning.se."
        />
        <meta
          name="keywords"
          content="hyra festutrustning skåne, event ljud ljus, företagsevent utrustning, mässa ljud, hyra scen skåne, bröllop ljud, studentflak, DJ skåne"
        />
        <link rel="canonical" href={baseUrl || 'https://festutrustning.se'} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={baseUrl || 'https://festutrustning.se'} />
        <meta
          property="og:title"
          content={`Hyra ljud & ljus i Skåne – fest, bröllop, företag${settings.company_name ? ` | ${settings.company_name}` : ''}`}
        />
        <meta
          property="og:description"
          content="Hyra PA, ljus och scen i Skåne med leverans och tydliga paket. Boka online för student, bröllop och företagsevent."
        />
        <meta property="og:image" content="https://festutrustning.se/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="theme-color" content="#7C3AED" />
      </Helmet>

      <LocalSEOSchema page="home" />
      <ReviewSchema />
      <PerformanceOptimizer />
      {/* Ordning: hero-copy + Hittills → booking-bar → Populärt just nu */}
      <Hero />
      <HomeBookingBar />
      <HomeShell>
        <FeaturedProducts />
        <CampaignSection />
        <BusinessAreasSection />
        <HowItWorks />
        <Reviews />
        <SponsorLogosSectionWrapper />
        <EventImagesSection />
        <Features />
        <BlogSection />
        <ProductBrandLogosSectionWrapper />
      </HomeShell>
    </>
  )
}

export default HomePage